import { authenticatedFetch } from '../../../api/utils/request';

export default async function getAppointments(startDate, endDate, setErrorMessage) {
    const onError = () => setErrorMessage('No se pueden obtener usuarios');
    return await authenticatedFetch(`/appointment-management/find-by-date/startDate/${startDate}/endDate/${endDate}`, onError);
}
